import { ParentProps } from "solid-js";

export default function Content(props: ParentProps) {
    return <>
        {props.children}
    </>
}
